module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm02"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/halftitle.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("#1 Without a Trace")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("#2 A Race Against Time")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("#3 False Notes")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("#4 High Risk")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("#5 Lights, Camera . . .")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("#6 Action!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("#7 The Stolen Relic")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("#8 The Scarlet Macaw Scandal")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("#9 Secret of the Spa")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("#10 Uncivil Acts")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("#11 Riverboat Ruse")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("#12 Stop the Clock")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("#13 Trade Wind Danger")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("#14 Bad Times, Big Crimes")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("#15 Framed")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("#16 Dangerous Plays")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("#17 En Garde")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("#18 Pit of Vipers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("#19 The Orchid Thief")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("#20 Getting Burned")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("#21 Close Encounters")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("#22 Dressed to Steal")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("#23 Troubled Waters")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("#24 Murder on the Set")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("#25 Trails of Treachery")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("#26 Fishing for Clues")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("#27 Intruder")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("#28 Mardi Gras Masquerade")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("#29 The Stolen Bones")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("#30 Pageant Perfect Crime")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("#31 Perfect Cover")]), _vm._v(" "), _c('p', {
    staticClass: "centera"
  }, [_c('strong', [_vm._v("Available from Aladdin Paperbacks")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-599bda9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm02.vue
// module id = 63
// module chunks = 0